import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from './ThemeContext';

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            onClick={toggleTheme}
            className="relative inline-flex h-9 w-16 items-center rounded-full bg-gray-200 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:bg-gray-700 shadow-inner"
            aria-label={theme === 'light' ? '다크 모드로 변경' : '라이트 모드로 변경'}
        >
            <span
                className={`${
                    theme === 'dark' ? 'translate-x-8 bg-gray-900' : 'translate-x-1 bg-white'
                } inline-flex h-7 w-7 transform items-center justify-center rounded-full transition-all duration-300 ease-in-out shadow-md`}
            >
                {theme === 'light' ? (
                    <Sun className="h-4 w-4 text-amber-500" />
                ) : (
                    <Moon className="h-4 w-4 text-indigo-400" />
                )}
            </span>
            <div className="absolute inset-0 flex items-center justify-between px-2 pointer-events-none">
                <Sun className={`h-3 w-3 text-amber-500 transition-opacity duration-300 ${theme === 'dark' ? 'opacity-100' : 'opacity-0'}`} />
                <Moon className={`h-3 w-3 text-indigo-400 transition-opacity duration-300 ${theme === 'light' ? 'opacity-100' : 'opacity-0'}`} />
            </div>
        </button>
    );
};

export default ThemeToggle;
